export { default } from './FlowLog.container'



// WEBPACK FOOTER //
// ./src/pages/FlowLog/index.js